<script>
	import { onMount } from 'svelte'

	let characters = ['🥳', '🎉', '✨']
    let frame

    let isLaunched = false

	let confetti = new Array(50).fill()
		.map((_, i) => {
			return {
				character: characters[i % characters.length],
				x: (Math.random() * 100) - 10,
				y: -20 - Math.random() * 100,
				r: 0.1 + Math.random() * 1
			}
		})
		.sort((a, b) => a.r - b.r)

	onMount(() => {
	})

    export const start = () => {
        if(isLaunched) return
        isLaunched = true
        loop()
    }

    export const stop = () => {
        cancelAnimationFrame(frame)
        isLaunched = false
        confetti = new Array(50).fill()
		.map((_, i) => {
			return {
				character: characters[i % characters.length],
				x: (Math.random() * 100) - 10,
				y: -20 - Math.random() * 100,
				r: 0.1 + Math.random() * 1
			}
		})
		.sort((a, b) => a.r - b.r)
    }

    const loop = () => {

        frame = requestAnimationFrame(loop)

        confetti = confetti.map(emoji => {
            emoji.y += 0.7 * emoji.r
            if (emoji.y > 130) emoji.y = -20
            return emoji
        })
    }

</script>

{#each confetti as c}
	<span style="left: {c.x}%; top: {c.y}%; transform: scale({c.r})" on:click="{stop}">{c.character}</span>
{/each}

<style>
	span {
		position: absolute;
		font-size: 32px;
		user-select: none;
	}
</style>
